export const isLocal = (hostname: string): boolean =>
  hostname.startsWith('localhost') ||
  hostname.startsWith('127.') ||
  hostname.startsWith('10.') ||
  hostname.startsWith('192.') ||
  hostname.endsWith('ngrok-free.app') ||
  hostname.startsWith('dev-ephemeral')
